<app-show-more [mobile-only]="true">
  <div class="car-detail__equipment-list">
    @for (item of category?.items; track item.id) {
      <app-show-more-item>
        <app-check-list-item>{{ item.title | firstCapital }}</app-check-list-item>
      </app-show-more-item>
    }
  </div>
</app-show-more>
